<app-offcanvas-base [returnUrl]="returnUrl">
  <ng-container title>
    <app-offcanvas-header-btn title="Remove subscription card"></app-offcanvas-header-btn>
  </ng-container>
  <ng-container body>
    @if (cardDetails) {
      <div class="text-center mt-5 mb-5">
        <img
          ngSrc="../../../../../../assets/graphics/remove-card.svg"
          alt=""
          width="188"
          height="148" />
      </div>
      <div class="h4">Are you sure you want to remove a "{{ cardDetails.name }}" subscription card?</div>
      <p class="text-muted">The cardholder will get notified that their subscription card has been removed.</p>
      <div class="row gy-3 offcanvas-buttons">
        <div class="col-12 col-sm-auto">
          <app-offcanvas-cancel-btn [returnUrl]="returnUrl"></app-offcanvas-cancel-btn>
        </div>
        <div class="col-12 col-sm-auto ms-sm-auto">
          <button
            class="btn btn-primary"
            (click)="onRemoveCard()">
            Yes, remove card
          </button>
        </div>
      </div>
    }
  </ng-container>
</app-offcanvas-base>
